export default "__VITE_ASSET__b6bac5f1__"